import React from 'react';
import { useNavigate } from 'react-router-dom';
import './HomePage.css';

const TermsPage = () => {
  const navigate = useNavigate();

  const handleStartTrial = () => {
    navigate('/register');
  };

  const handleLogin = () => {
    navigate('/login');
  };

  const handleWatchDemo = () => {
    // You can implement demo functionality here
    alert('Demo video will be available soon!');
  };

  return (
    <div className="main-container">
      {/* Navigation */}
      <nav className="navbar">
        <div className="nav-container">
          <div className="nav-content">
            <div className="logo-section">
              <div className="logo-icon">
                <svg className="scissors-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="6" cy="6" r="3"/>
                  <path d="m21.5 21.5-5-5"/>
                  <path d="m12 12-5-5"/>
                  <path d="m9 9 5 5"/>
                  <circle cx="6" cy="18" r="3"/>
                  <path d="m21.5 2.5-5 5"/>
                </svg>
              <span className="logo-text">ClickLooks</span>
              </div>
            </div>
            <div className="nav-buttons">
              <button className="btn-ghost" onClick={handleLogin}>Login</button>
              <button className="btn-premium btn-sm" onClick={handleStartTrial}>Start Free Trial</button>
            </div>
          </div>
        </div>
      </nav>
 

      {/* Features Grid */}
      <section className="features-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Terms & Conditions</h2> 
          </div> 
          <p>Welcome to <strong>ClickLooks</strong>, a salon management software operated by <strong>jsnsoft</strong>. By accessing or using our website and services, you agree to comply with and be bound by the following Terms & Conditions. If you do not agree with these terms, please do not use our services.</p>

<p><strong>1. Service Description</strong><br/>
ClickLooks provides a cloud-based salon management platform that enables salon owners to manage appointments, customers, billing, reports, and related business operations. We reserve the right to modify, suspend, or discontinue any feature of the service at any time without prior notice.</p>

<p><strong>2. Account Registration</strong><br/>
To use ClickLooks, you must create an account and provide accurate and complete information. You are responsible for maintaining the confidentiality of your login credentials and for all activities that occur under your account. You agree to notify us immediately of any unauthorized access at <strong><a href="mailto:info@clicklooks.com">info@clicklooks.com</a></strong>.</p>

<p><strong>3. Subscription & Payments</strong><br/>
ClickLooks operates on a subscription-based model. By subscribing, you agree to pay the applicable fees as displayed at the time of purchase. Payments are processed through secure third-party payment gateways. Failure to pay subscription fees may result in suspension or termination of your access to the service.</p>

<p><strong>4. Refund Policy</strong><br/>
All payments made to ClickLooks are <strong>final and non-refundable</strong>. We do not provide refunds for subscription fees, partial usage periods, unused features, early cancellation, or account inactivity. Once a payment has been processed successfully, it cannot be reversed.<br/><br/>
Users are encouraged to evaluate the service during any available trial period before purchasing a paid subscription. If you have billing-related questions, you may contact us at <strong><a href="mailto:info@clicklooks.com">info@clicklooks.com</a></strong>.</p>

<p><strong>5. Data Ownership</strong><br/>
All customer and business data entered into ClickLooks remains the property of the respective salon owner. ClickLooks acts solely as a <strong>data processor</strong> and does not claim ownership over your data. You are responsible for ensuring that the data you collect and store complies with applicable laws.</p>

<p><strong>6. Acceptable Use</strong><br/>
You agree not to use ClickLooks for any unlawful, harmful, fraudulent, or abusive activity. You must not attempt to gain unauthorized access to our systems, interfere with service operations, upload malicious code, or misuse the platform in any way.</p>

<p><strong>7. Intellectual Property</strong><br/>
All content, software, design elements, logos, and features of ClickLooks are the intellectual property of <strong>jsnsoft</strong>. You may not copy, reproduce, distribute, modify, or reverse engineer any part of the platform without prior written consent.</p>

<p><strong>8. Service Availability</strong><br/>
We strive to maintain reliable service availability; however, we do not guarantee uninterrupted or error-free operation. Maintenance, updates, or technical issues may cause temporary downtime.</p>

<p><strong>9. Limitation of Liability</strong><br/>
To the maximum extent permitted by law, ClickLooks and jsnsoft shall not be liable for any indirect, incidental, special, or consequential damages arising from the use or inability to use the service. Use of the platform is at your own risk.</p>

<p><strong>10. Termination</strong><br/>
We reserve the right to suspend or terminate your account if you violate these Terms & Conditions or misuse the platform. Upon termination, access to your account may be restricted or removed.</p>

<p><strong>11. Privacy</strong><br/>
Your use of ClickLooks is also governed by our <strong>Privacy Policy</strong>. By using our services, you agree to the collection and use of information as described in that policy.</p>

<p><strong>12. Governing Law</strong><br/>
These Terms & Conditions shall be governed by and interpreted in accordance with applicable laws. Any disputes arising out of these terms shall be subject to the jurisdiction of the appropriate courts.</p>

<p><strong>13. Changes to Terms</strong><br/>
We may update these Terms & Conditions from time to time. Updated versions will be posted on this page with a revised effective date. Continued use of the service after updates constitutes acceptance of the revised terms.</p>

<p>If you have any questions regarding these Terms & Conditions, please contact us at <strong><a href="mailto:info@clicklooks.com">info@clicklooks.com</a></strong>.</p>

        </div>
      </section>
  
      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-logo">
              <div className="logo-icon">
                <svg className="scissors-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="6" cy="6" r="3"/>
                  <path d="m21.5 21.5-5-5"/>
                  <path d="m12 12-5-5"/>
                  <path d="m9 9 5 5"/>
                  <circle cx="6" cy="18" r="3"/>
                  <path d="m21.5 2.5-5 5"/>
                </svg>
              </div>
              <span className="logo-text">ClickLooks</span>
            </div>
            <div className="footer-links">
            <a href="/" className="footer-link">Home</a>
              <a href="/privacy" className="footer-link">Privacy</a>
              <a href="/terms" className="footer-link">Terms</a> 
              <a href="https://api.whatsapp.com/send?phone=+918555086630&text=Hello%20ClickLooks&source=&data=" className="footer-link">Contact</a>
            </div>
          </div>
          <div className="footer-bottom">
            © 2024 ClickLooks. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default TermsPage;
